import React from 'react';
import DfbRte from '../ui-kit/dfb_rte';
import Section from "./section"

const MTextHighlight = (props) => {
  return (
    <Section
      baseClass="m-TextHighlight"
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-TextHighlight-wrapper">
        <div className="m-TextHighlight-container">
          <blockquote className="m-TextHighlight-highlight">
            <div className="m-TextHighlight-highlightSmall">{props.data.highlight_text}</div>
          </blockquote>
          <DfbRte text={props.data.text} add_class="m-TextHighlight-text" />
        </div>
      </div>
    </Section>
  );
}

export default MTextHighlight;
